import orgloginApi from '@/api/orglogin'
import { getToken, setToken, removeToken } from '@/utils/auth'
import {encrypted} from '@/utils/encrypt'
import configJosn from '../../../static/config.json'
const user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: getToken(),
    name: '',
    nick: '',
    introduction: '',
    visitor: false,
    setting: {
      articlePlatform: []
    }
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_NICK: (state, nick) => {
      state.nick = nick
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMS: (state, perms) => {
      state.perms = perms
    },
    SET_VISITOR: (state, visitor) => {
      state.visitor = visitor
    }
  },

  actions: {
    getProcedureGuid(){
      return configJosn.procedureGuid;
    },
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const userPassword = encrypted(userInfo.password)
      return new Promise((resolve, reject) => {
        var outUserData = {
          "loginName": username,
          "loginPassword": userPassword,
          "procedureGuid": configJosn.procedureGuid,
        }
        orgloginApi.getOrgByUserInfo(outUserData).then(response => {
          console.log('拦截器返回，处理数据。')
          const data = response.data
          commit('SET_TOKEN', data.token)
          setToken(response.data.token)
          resolve()
        }).catch(error => {
          console.log(error);
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        var tokenJson = {
          token: state.token
        }
        orgloginApi.getuserInforByToken(tokenJson).then(res => {
          if (!res) reject('res is null');
          if (!res.data) reject('res.data is null');
          if(res.data.code == 0){
            setToken(res.data.token)
            commit('SET_TOKEN', res.data.token)
            commit('SET_NICK', res.data.data.name)
            commit('SET_NAME', res.data.data.name)
            resolve(res)
          }else{
            commit('SET_VISITOR', false)
          }
          commit('SET_NICK', res.data.data.nick)
          commit('SET_NAME', res.data.data.uname)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetOrgInfoByIp({ commit, state }) {
      return new Promise((resolve, reject) => {
        var ipLoginInfo = {
          "procedureGuid": configJosn.procedureGuid,
        }
        orgloginApi.getOrgByIp(ipLoginInfo).then(res => {
          if(res.data.code == 0){
            commit('SET_TOKEN', res.data.token)
            setToken(res.data.token)
            //commit('SET_NICK', res.data.data.name)
            //commit('SET_NAME', res.data.data.name)
            resolve(res)
          }else{
            console.log('ip login fail ',res)
            reject(res.msg);
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js